import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/css/spacing.css";
import "./assets/css/css/theme.css";
import "./assets/css/css/typography.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "@reduxjs/toolkit";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import theme from "./assets/css/theme";
import "./App.css";
import rootReducer from "./store/reducers";
import thunk from "redux-thunk";
import { BrowserRouter } from "react-router-dom";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart,
  ArcElement,
  Legend,
  Tooltip,
  CategoryScale,
  LinearScale,
  registerables,
} from "chart.js";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
Chart.register(
  ArcElement,
  Legend,
  Tooltip,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  ...registerables
);

const store = configureStore({ reducer: rootReducer, middleware: [thunk] });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        maxSnack={4}
        autoHideDuration={2000}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
